import React from 'react';
import Banner from './banner';
import Block1 from './block1';
import Block2 from './block2';
import Block4 from './block4';

const Home = props => (
    <div>
        <Banner />
        <Block1 />
        <Block2 />
        <Block4 />
    </div>
);

export default Home;


// WEBPACK FOOTER //
// ./src/containers/home/index.js